/**
 * Mapa de las celdas que ocupa la rampa
 */
export default [
    // Parte de la izquierda 
    [6,6], [7,6], [8,6], [9,6], [10,6], [11,6], [12,6], [13,6], [14,6], [15,6], [16,6],
    [6,7], [7,7], [8,7], [9,7], [10,7], [11,7], [12,7], [13,7], [14,7], [15,7], [16,7],
    
    // Parte de la izquierda 
    [6,13], [7,13], [8,13], [9,13], [10,13], [11,13], [12,13], [13,13], [14,13], [15,13], [16,13],
    [6,14], [7,14], [8,14], [9,14], [10,14], [11,14], [12,14], [13,14], [14,14], [15,14], [16,14],
    
    // Parte de abajo
    [15,8], [15,9], [15,10], [15,11], [15,12],
    [16,8], [16,9], [16,10], [16,11], [16,12],
    [14,8], [14,9], [14,10], [14,11], [14,12],

    // Celdas adicionales
    [6,11], [6,12], [7,11], [7,12], [8,12], [9,12],
];


// WEBPACK FOOTER //
// ./src/RampaCells.js